<template>
    <div class="whitespace-nowrap [&:not(:hover)]:truncate hover:whitespace-normal ">
        {{ nextActionLabel }}
        <!-- <select @blur="addNewNextStep" class="border rounded-md p-1" v-model="crmDetailType" name="" id="">
            <option v-for="detailType in crmDetailTypes" :key="detailType.id" :value="detailType.id">
                {{ detailType.unresolved_label }}
            </option>
        </select> -->
    </div>
</template>

<script setup>
import {ref, computed, defineProps, defineEmits, watch} from 'vue'

const props = defineProps([
    'nextStep', 'crmDetailTypes'
])

const emit = defineEmits([
    'add-new-next-step'
])

const crmDetailType = ref(props.nextStep ? props.nextStep.action_id : null)

const nextActionLabel = computed(() => {
    if(props.nextStep){
        return props.nextStep.action.unresolved_label
    } else {
        return '--'
    }
})

const initialCrmDetailType = computed(() => {
    return props.nextStep.action_id
})



watch(() => props.nextStep, () => {
    crmDetailType.value = props.nextStep.action_id
})

function addNewNextStep(){
    if(initialCrmDetailType.value != crmDetailType.value){
        emit('add-new-next-step', crmDetailType)
    } else {
        console.log('no change')
    }
}

</script>